import { PoolDetail } from '@/modules/pools/pool-detail'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/pools/$pool')({
  component: PoolDetail,
})
